import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const OPTIONS = [
  { key: 'A', field: 'option1' },
  { key: 'B', field: 'option2' },
  { key: 'C', field: 'option3' },
  { key: 'D', field: 'option4' },
];

const sameId = (a, b) => String(a) === String(b);

const QuestionOptions = ({
  question,
  savedbackup,
  markedbackup,
  selectedAnswer,
  onChange,
}) => {
  if (!question) return null;

  return (
    <div className="answer-list" role="radiogroup" aria-label="Answer options">
      {OPTIONS.map(({ key, field }) => {
        const optionValue = question[field] || '';

        const savedItem = (savedbackup || []).find(
          item => sameId(item.q_id, question.q_id) && (
            String(item.answer).toUpperCase() === key || item.answer === optionValue
          )
        );

        const markedItem = (markedbackup || []).find(
          item => sameId(item.q_id, question.q_id) && (
            String(item.answer).toUpperCase() === key || item.answer === optionValue
          )
        );

        const stateClass = savedItem
          ? 'answer-option answer-option--answered'
          : markedItem
            ? 'answer-option answer-option--marked'
            : 'answer-option';

        return (
          <label className={stateClass} htmlFor={`answer-${question.q_id}-${key}`} key={key}>
            <input
              type="radio"
              name={`answer-${question.q_id}`}
              value={key}
              id={`answer-${question.q_id}-${key}`}
              checked={selectedAnswer === key}
              onChange={onChange}
            />
            <span className="answer-option__letter">{key}</span>
            <span className="answer-option__text">{ReactHtmlParser(optionValue)}</span>
          </label>
        );
      })}
    </div>
  );
};

export default QuestionOptions;
